import request from "@/plugin/axios";
import axios from "axios";
import util from "@/libs/util";
const token = util.cookies.get("token");
export function uploadTable(data, token) {
  return axios({
    url: process.env.VUE_APP_API + "/api/case/czCaseInfo/importCaseExcel",
    method: "post",
    dataType: "json",
    responseType: "application/json",
    data: data,
    headers: {
      authorization: "Bearer " + token,
    },
  });
}
export function batchSetStatus(data) {
  return request({
    url: '/api/case/czCaseInfo/batchSetStatus',
    method: 'post',
    data
  })

}

export function batchRemark(data) {
  return request({
    url: '/api/case/czCaseRemarkLog/addLog',
    method: 'post',
    data
  })
}
export function deleteCase(id) {
  return request({
    url: "api/case/liveCaseInfo/deleteCase/" + id,
    method: "delete",
  });
}

export function upLoadCaseFile(data) {
  return request({
    url: "api/case/liveCaseFiles/upload",
    method: "post",
    responseType: "application/json",
    data,
  });
}
export function deleteCaseUploadFile(caseId) {
  return request({
    url: "api/case/liveCaseFiles/" + caseId,
    method: "delete",
  });
}
export function startDisposal(caseId) {
  return request({
    url: "api/case/liveCaseInfo/startChuZhi/" + caseId,
    method: "post",
  });
}

export function submitCourt(data) {
  return request({
    url: "api/case/liveCaseInfo/submitCourt",
    method: "post",
    data,
  });
}
export function registered(data) {
  return request({
    url: "/api/case/liveCaseInfo/yiLiAn",
    method: "post",
    data,
  });
}
export function pay(data) {
  return axios({
    url: process.env.VUE_APP_API + "/api/case/liveCaseInfo/yiJiaoFei",
    method: "post",
    dataType: "json",
    responseType: "application/json",
    data: data,
    headers: {
      authorization: "Bearer " + token,
    },
  });
}

export function caseAbnormal(data) {
  return axios({
    url: process.env.VUE_APP_API + "/api/case/liveCaseInfo/caseYiDong",
    method: "post",
    dataType: "json",
    responseType: "application/json",
    data: data,
    headers: {
      authorization: "Bearer " + token,
    },
  });
}
export function judgement(id) {
  return request({
    url: "/api/case/liveCaseInfo/yiKaiTing/" + id,
    method: "post",
  });
}
export function scheduling(data) {
  return axios({
    url: process.env.VUE_APP_API + "/api/case/liveCaseInfo/yiPaiQi",
    method: "post",
    dataType: "json",
    responseType: "application/json",
    data: data,
    headers: {
      authorization: "Bearer " + token,
    },
  });
}
export function judgementEnd(data) {
  return axios({
    url: process.env.VUE_APP_API + "/api/case/liveCaseInfo/yiPanJue",
    method: "post",
    dataType: "json",
    responseType: "application/json",
    data: data,
    headers: {
      authorization: "Bearer " + token,
    },
  });
}
export function getFileList(id) {
  return request({
    url: "/api/case/liveCaseFiles/getLiveCaseFilesByCaseId/" + id,
    method: "get",
  });
}

export function addParty(data) {
  return request({
    url: "/api/case/liveParty/addLiveParty",
    method: "post",
    data,
  });
}

export function deleteParty(id) {
  return request({
    url: "/api/case/liveParty/" + id,
    method: "delete",
  });
}

export function updateParty(data) {
  return request({
    url: "/api/case/liveParty/updateLiveParty",
    method: "put",
    data,
  });
}

export function addElement(data) {
  return request({
    url: "/api/case/liveCaseElement/addLiveCaseElement",
    method: "post",
    data,
  });
}

export function updateElement(data) {
  return request({
    url: "/api/case/liveCaseElement/updateLiveCaseElement",
    method: "put",
    data,
  });
}

export function deleteElement(id) {
  return request({
    url: "/api/case/liveCaseElement/" + id,
    method: "delete",
  });
}

export function getList(data) {
  return request({
    url: "/api/case/czCaseInfo/newCaseList",
    method: "post",
    data,
  });
}

export function addCase(data) {
  return axios({
    url: process.env.VUE_APP_API + "/api/case/liveCaseInfo/caseBaseInfo",
    method: "post",
    dataType: "json",
    responseType: "application/json",
    data: data,
    headers: {
      authorization: "Bearer " + token,
    },
  });
}

export function getLiveCaseInfo(id) {
  return request({
    url: "/api/case/liveCaseInfo/singleCase/" + id,
    method: "get",
  });
}

export function identifyIdCard(data, token) {
  return axios({
    url: process.env.VUE_APP_API + "/api/case/liveCaseInfo/ocrIdCard",
    method: "post",
    dataType: "json",
    responseType: "application/json",
    data: data,
    headers: {
      authorization: "Bearer " + token,
    },
  });
}

export function updateLiveCaseInfo(id, data) {
  return request({
    url: "/api/case/liveCaseInfo/" + id,
    method: "put",
    data,
  });
}
